import React, {Component} from 'react'
import {Link} from 'react-router-dom'

import Header from "../components/Header";
import Footer from '../components/Footer'

const Sitepolicy = () => (
    <div>
        <Header/>
        <div className="content partslist-page">
            <div className="container">
                <div className="pb-5">
                    <h1 className="title-partslist-page">サイトポリシー</h1>
                    <div className="img-three-dot">
                        <img src="images/three-dot.png" className="img-fluid"/>
                    </div>
                    <div className="description-item-parts">
                        当サイトは、株式会社dsc（以下：弊社）が管理・運営しています。以下の内容をご確認いただき、ご了解の上でご利用（以下、当サイトの利用者を「ご利用者」といいます）ください。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>１．はじめに</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、当サイトに掲載されたコンテンツにつき、その適合性、有用性、正確性、完全性、権限の存在、および権利の非侵害を保証するものではなく、弊社はコンテンツを予告なく変更することがあります。予めご了承ください。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>２．著作権について</span>
                    </h2>
                    <div className="description-item-parts">
                        当サイトに掲載されているコンテンツの内容に関する一切の権利は、特に記載のない限り、弊社に帰属します。当サイトのコンテンツは、著作権法、著作権に関する条約、およびその他の法律で保護されています。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>３．免責事項について</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、当サイトの内容およびコンテンツについては細心の注意を払っておりますが、いかなる保証をするものではありません。<br/>
                        <br/>
                        弊社は、当サイト内のコンテンツを予告なく変更・廃止することがあります。また、当サイトの利用によりご利用者がいかなる損害を受けた場合であっても、弊社はすべての損害より免責され、何らの責任を負いません。ご利用にあたってはご注意ください。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>４．リンクについて</span>
                    </h2>
                    <div className="description-item-parts">
                        当サイトからリンクを貼っている、弊社以外のサイトの内容は、リンク先の各社・各団体の責任で管理・運営されており、弊社の管理監督下にはありません。弊社は、リンク先のサイトの内容、ご利用になったことにより生じたいかなる損害についても何らの責任を負いません。<br/>
                        <br/>
                        当サイトにリンクする場合には、以下のいずれかに該当する場合には、お断りします。<br/>
                        <br/>
                        （１） 弊社を誹謗中傷する内容または信用を毀損する内容よりリンクすること。<br/>
                        （２） 違法なコンテンツを掲載したり、違法な活動に関与したり、または関与した可能性のある内容よりリンクすること。<br/>
                        （３） 公序良俗に反する内容よりリンクすること。<br/>
                        （４） フレームその他の方法で弊社サイトのコンテンツであることが不明になる方法によりリンクすること。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>５．クッキー（Cookie）の利用について</span>
                    </h2>
                    <div className="description-item-parts">
                        当サイトの一部では、クッキーを使用しています。<br/>
                        <br/>
                        クッキーによりご利用者の個人情報を読み取ることはありません。また、違法な目的でクッキーを使用することはありません。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>６． 準拠法について</span>
                    </h2>
                    <div className="description-item-parts">
                        当サイトならびにサイトポリシーの解釈および適用は、日本国法に準拠するものとします。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>７．サイトポリシー改訂の告知について</span>
                    </h2>
                    <div className="description-item-parts">
                        弊社は、サイトポリシーの全部または一部を予告なく改訂することがあります。改訂されたサイトポリシーは、当サイトに掲載された時点より効力を有するものとします。
                    </div>
                    <h2 className="h2-tag-parts">
                        <img src="images/icon_03.png" className="img-fluid mr-3"/>
                        <span>８．ご利用環境について</span>
                    </h2>
                    <div className="description-item-parts">
                        当サイトでは、以下の環境でのご利用を推奨しております。<br/>
                        <br/>
                        【ブラウザ】<br/>
                        Windows版<br/>
                        ・Google Chrome 最新版<br/>
                        ・Firefox 最新版<br/>
                        ・Safari 最新版<br/>
                        ・Internet Explorer 11.0以降<br/>
                        <br/>
                        Macintosh版<br/>
                        ・Safari 最新版<br/>
                        ・Google Chrome 最新版<br/>
                        ・Firefox 最新版<br/>
                        <br/>
                        当サイトでは、JavaScriptおよびスタイルシートを使用しております。快適にご利用いただくために、ブラウザの設定でJavaScriptおよびスタイルシートを有効にした上でご利用いただきますようお願いいたします。
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
)

export default Sitepolicy